var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardLocked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1546 20.9985V38.1167H12.8849V20.9985C12.8849 20.8485 13.0782 20.583 13.5167 20.583H36.5228C36.9613 20.583 37.1546 20.8485 37.1546 20.9985Z",
    stroke: "#051029",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4343 19.246V14.1515C14.4343 8.99184 18.3106 4.81152 23.095 4.81152C27.8794 4.81152 31.7557 8.99184 31.7557 14.1515V19.246",
    stroke: "#051029",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6049 36.5669V19.0737C35.6049 18.6371 35.1542 18.2832 34.5981 18.2832H11.592C11.036 18.2832 10.5852 18.6371 10.5852 19.0737V36.5669H35.6049Z",
    fill: "#489BD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9619 28.1049L24.8852 28.2056V28.3322V30.312C24.8852 31.4619 24.0387 32.3427 23.095 32.3427C22.1513 32.3427 21.3049 31.4619 21.3049 30.312V28.3322V28.2056L21.2281 28.1049C20.8406 27.5964 20.5831 26.9903 20.5831 26.3024C20.5831 24.7093 21.7525 23.4697 23.095 23.4697C24.4376 23.4697 25.6069 24.7093 25.6069 26.3024C25.6069 26.9903 25.3495 27.5964 24.9619 28.1049Z",
    fill: "#CEE0EC",
    stroke: "#051029",
    strokeWidth: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4576 18.409C33.4455 18.4002 33.4332 18.3916 33.4206 18.3832H34.6426C34.8893 18.3832 35.1087 18.4566 35.264 18.5704C35.4193 18.6842 35.5049 18.8331 35.5049 18.9883V36.4669H33.7803V18.9883C33.7803 18.754 33.6505 18.5504 33.4576 18.409Z",
    fill: "#004288",
    stroke: "#489BD5",
    strokeWidth: 0.2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardLocked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CardLocked.24f6e73e27f3a89dc775e26664b1c849.svg";